export default {
    component: 'aggregate_parameter_config',
    name: 'aggregate_parameter_config',
    fields: [{
        name: 'Device',
        param: 'device',
        type: 'text',
        identifier: true,
        required: true,
      },
      {
        name: 'Parameter Config',
        param: 'parameter_config',
        type: 'json',
      },
      {
        name: 'Parameter List',
        param: 'parameter_list',
        type: 'text',
      }
    ]
  }
